export function resolveQuotationSignatoryCompany(args: {
  name?: string;
  email?: string;
  company?: string;
  entity?: string;
}): string {
  const name = (args.name || '').trim().replace(/\s+/g, ' ').toLowerCase();
  const email = (args.email || '').trim().toLowerCase();
  // Wilson signs on behalf of Equilibrium even when directory company data is stale.
  if (name === 'wilson du' || email === 'wdu@eqeng.com.au' || email === 'wd@linfinityeng.com') {
    return 'Equilibrium Engineering Pty Ltd';
  }
  return (args.company || '').trim() || (args.entity || '').trim() || 'Linfinity Engineering Pty Ltd';
}
